import * as tslib_1 from "tslib";
import React from 'react';
import { FormHelpText } from 'sinoui-components/Form';
import styled from 'sinoui-components/styles';
import { connect } from 'formik';
var CustomFormHelpText = styled(FormHelpText)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-left: ", ";\n"], ["\n  padding-left: ", ";\n"])), function (props) { return props.paddingLeft || '120px'; });
/**
 * 表单项错误提示。
 */
var FormItemError = function (_a) {
    var name = _a.name, errorMessageType = _a.errorMessageType, formik = _a.formik, paddingLeft = _a.paddingLeft;
    if (!formik || Object.keys(formik).length === 0 || !name) {
        return null;
    }
    var _b = formik.errors, errors = _b === void 0 ? {} : _b, _c = formik.touched, touched = _c === void 0 ? {} : _c;
    return errorMessageType !== 'none' && touched[name] && errors[name] ? (React.createElement(CustomFormHelpText, { paddingLeft: paddingLeft, error: true }, errors[name])) : null;
};
export default connect(FormItemError);
var templateObject_1;
//# sourceMappingURL=FormItemError.js.map